'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgTextSize = require('svg-text-size');

var _svgTextSize2 = _interopRequireDefault(_svgTextSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Takes a string, and a width (and svg attrs, if they apply), and returns
// an array of lines, representing the break points in the string.
var svgTextWrap = function svgTextWrap(text, width, attrs) {
  var doc = arguments.length <= 3 || arguments[3] === undefined ? document : arguments[3];

  var words = text.split(/\s+/);
  var lines = [];
  var currentLine = [];
  words.forEach(function (word) {
    var newLine = [].concat(_toConsumableArray(currentLine), [word]);
    var size = (0, _svgTextSize2.default)(newLine.join(' '), attrs, doc);
    if (size.width > width) {
      lines.push(currentLine.join(' '));
      currentLine = [word];
    } else {
      currentLine.push(word);
    }
  });
  lines.push(currentLine.join(' '));
  if (lines[0] === '') {
    lines.shift();
  }
  return lines;
};

exports.default = svgTextWrap;